(function () {
    const SELECTORS = {
        wrapper: '.js-infinite-scroll',
        grid: '.js-product-grid',
        loader: '.js-infinite-scroll-loader',
        trigger: '.js-infinite-scroll-trigger'
    };

    function initInfiniteScroll(scope) {
        const root = scope || document;
        const wrappers = root.querySelectorAll(SELECTORS.wrapper);

        wrappers.forEach(function (wrapper) {
            if (wrapper.dataset.infiniteReady === 'true') return;
            wrapper.dataset.infiniteReady = 'true';

            const grid = wrapper.querySelector(SELECTORS.grid);
            const loader = wrapper.querySelector(SELECTORS.loader);
            const trigger = wrapper.querySelector(SELECTORS.trigger);

            if (!grid || !trigger) return;

            let isLoading = false;
            let observer = null;

            function setLoadingState(state) {
                isLoading = state;

                if (loader) {
                    loader.style.display = state ? 'block' : 'none';
                }
            }

            function destroyControls() {
                if (loader) loader.remove();
                if (trigger) trigger.remove();
                if (observer) observer.disconnect();
            }

            async function loadNextPage() {
                const nextUrl = wrapper.dataset.nextUrl;

                if (!nextUrl || isLoading) return;

                setLoadingState(true);

                try {
                    const response = await fetch(nextUrl, {
                        method: 'GET',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    });

                    if (!response.ok) {
                        throw new Error('Request failed: ' + response.status);
                    }

                    const html = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    const newWrapper = doc.querySelector(SELECTORS.wrapper);
                    const newGrid = doc.querySelector(SELECTORS.grid);

                    if (!newWrapper || !newGrid) {
                        throw new Error('Infinite scroll markup not found in response');
                    }

                    grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);

                    const newNextUrl = newWrapper.dataset.nextUrl || '';
                    wrapper.dataset.nextUrl = newNextUrl;

                    if (!newNextUrl) {
                        destroyControls();
                    }
                } catch (error) {
                    console.error('Infinite scroll error:', error);
                } finally {
                    setLoadingState(false);
                }
            }

            observer = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            loadNextPage();
                        }
                    });
                },
                {
                    rootMargin: '300px 0px'
                }
            );

            observer.observe(trigger);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initInfiniteScroll(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        initInfiniteScroll(event.target);
    });

    document.addEventListener('shopify:section:reorder', function (event) {
        initInfiniteScroll(event.target);
    });
})();